import { render, staticRenderFns } from "./UserSettingsGUI.vue?vue&type=template&id=32a01876&scoped=true&"
import script from "./UserSettingsGUI.vue?vue&type=script&lang=js&"
export * from "./UserSettingsGUI.vue?vue&type=script&lang=js&"
import style0 from "./UserSettingsGUI.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UserSettingsGUI.vue?vue&type=style&index=1&id=32a01876&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a01876",
  null
  
)

export default component.exports
import {QCard,QCardSection,QItem,QSelect,QIcon,QBtn,QInnerLoading,QSpinnerGears,QField} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QItem,QSelect,QIcon,QBtn,QInnerLoading,QSpinnerGears,QField}, component.options.components || {})
